import React from 'react';
import { connect } from 'react-redux';

import * as actions from '../../../../store/actions/index';
import LineChart from '../../../Charts/LineChart';

const LineEvolucionCompras = (props) => { 
  return (
    <LineChart
      title={'Evolución de compras por mes'}
      categories={props.compras && props.compras.map((venta) => {
          return new Date(venta.anio, venta.mes - 1, 1);
        })
      }
      textoTooltip='Monto'
      series={props.compras && props.compras.map((venta) => venta.monto)}
      width={props.width}
      loading={props.loading}
      imgSinDatos={props.compras.length === 0}
      showXLabels
      labelsRotateAlways
      onFiltersClick={() => props.onShowFiltersModal()}
      height={props.height}
      minHeight={props.minHeight}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    compras: state.proveedores.comprasPorMes.compras,
    loading: state.proveedores.comprasPorMes.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onShowFiltersModal: () => dispatch(actions.showListFiltersModal(true, 'Evolución de compras por mes', ['venta']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LineEvolucionCompras);
